'use client';
import { useState, useEffect, useRef, useMemo, useCallback, memo } from 'react';
import React from 'react';
import {
   Box,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   Spinner,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorMode,
   useColorModeValue,
   useDisclosure,
   useOutsideClick,
} from '@chakra-ui/react';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import { Button, Image, Thead, Th, Grid } from '@chakra-ui/react';
import Select from 'react-select';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import ColumnShowHide from '../components/Columnshowhide';
import {
   clearCacheReport,
   deleteReportFormat,
   getBillToBillProfit,
   getReportFormat,
} from '../../../../redux/actions/reports';
import { createColumnHelper } from '@tanstack/react-table';
import { getAccount } from '../../../../redux/actions/account';
import { useGlobal, useUser } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { MdCompress, MdDelete, MdExpand } from 'react-icons/md';
import SalesPurchaseFilter from '../components/SalesPurchaseFilter';
import * as XLSX from 'xlsx-js-style';
import { debounce } from 'lodash';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import SalesSingleDataView from '../../sales/Pages/SalesInvoiceMaster/SaleSingleDataView';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import autoTable from 'jspdf-autotable';
import { IoFilterOutline } from 'react-icons/io5';
import { LucideEdit } from 'lucide-react';
import { FiPlusCircle } from 'react-icons/fi';
import moment from 'moment';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import { VariableSizeList } from 'react-window';
import { id } from 'zod/v4/locales';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

// Constants for row heights
const ROW_HEIGHTS = {
   COMPANY_HEADER: 65,
   DAYBOOK_HEADER: 55,
   TRANSACTION_ROW: 40,
   EMPTY_ROW: 30,
   LOADING_ROW: 100,
   NO_DATA_ROW: 100,
};

// Memoized components to prevent unnecessary re-renders
const FormattedNumber = memo(({ value }) => {
   if (value === undefined || value === null) return '-';

   const absBal = Math.abs(value);
   const formattedVal = absBal.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });

   const [intPart, decimalPart] = formattedVal.split('.');

   return (
      <Box display="flex" justifyContent="flex-end" gap="1px" whiteSpace="nowrap">
         <Text fontWeight={600}>
            {value >= 0 ? '' : '-'} {intPart}
         </Text>
         <Text fontSize={{ base: '9px', md: '10px' }} fontWeight={600}>
            .{decimalPart}
         </Text>
      </Box>
   );
});
const FormattedNumberForGrandTotal = memo(({ value }) => {
   if (value === undefined || value === null) return '-';

   const absBal = Math.abs(value);
   const formattedVal = absBal.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });

   const [intPart, decimalPart] = formattedVal.split('.');

   return (
      <Box
         display="flex"
         justifyContent="flex-end"
         alignItems="baseline"
         gap="1px"
         whiteSpace="nowrap"
         width="100%">
         <Text
            fontWeight={600}
            fontSize={{ base: '12px', md: '13px' }}>
            {value >= 0 ? '' : '-'}{intPart}
         </Text>
         <Text
            fontSize={{ base: '9px', md: '10px' }}
            fontWeight={600}>
            .{decimalPart}
         </Text>
      </Box>
   );
});

const storedCompanyId = localStorage.getItem('companyId');

// Virtualized DataRow component
const DataRow = memo(
   ({
      row,
      isOddRow,
      borderColor,
      formatDate,
      setIsOpenPurchaseReturnSingleView,
      setEntityType,
      setIsOpenSingleViewinr,
      dynamicOptionValues,
      viewJson,
      style,
   }) => {
      const dispatch = useDispatch();
      const { user } = useUser();
      const admin = user?.isAdmin;
      const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      const handledata = async (data) => {
         const companyId = parseInt(storedCompanyId);
         if (data.companyId === companyId && data.daybookType === 20 && (admin || rights?.inventoryreceive?.view)) {
            setEntityType('receivemaster');
            const response = await dispatch(getReceiveInventory(data.headerId));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.companyId === companyId && data.daybookType === 19 && (admin || rights?.inventoryissue?.view)) {
            setEntityType('issuemaster');
            const response = await dispatch(getIssueInventory(data.headerId));
            await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
            setIsOpenSingleViewinr(true);
         }
         if (data.companyId === companyId && data.daybookType === 11 && (admin || rights?.purchaseinvoice?.view)) {
            setEntityType('purchaseinvoice');
            await dispatch(getPurchaseInvoice(data.headerId));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 5 && (admin || rights?.saleinvoice?.view)) {
            setEntityType('saleinvoice');
            await dispatch(getSaleInvoice(data.headerId));
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 12 && (admin || rights?.purchasereturn?.view)) {
            setEntityType('purchasereturn');
            await dispatch(getSinglePurchaseReturn(data.id));
            await dispatch(
               getSinglePurchaseReturnWithPrevAndNext({
                  id: data.id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
         if (data.companyId === companyId && data.daybookType === 6 && (admin || rights?.salereturn?.view)) {
            setEntityType('salereturn');
            await dispatch(
               getSingleSalesReturnWithPrevAndNext({
                  id: data.id,
                  page: 1,
                  limit: 1,
                  sortBy: 'id',
                  sortOrder: 'desc',
               }),
            );
            setIsOpenPurchaseReturnSingleView(true);
         }
      };

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const rowClasses = `
         border-t border-${isDark ? 'gray-700' : 'gray-200'}
         cursor-pointer transition-all duration-200 ease-in-out
         hover:bg-${isDark ? 'blue-900/20' : 'blue-50'}
         ${isOddRow ? (isDark ? 'bg-gray-800/30' : 'bg-blue-50/30') : 'bg-transparent'}
         h-10 md:h-10
      `;

      if (dynamicOptionValues) {
         const visibleColumns = viewJson?.filter((item) => item.isShow) || [];

         return (
            <tr key={`row-${row.docid}`} className={rowClasses} onClick={() => handledata(row)} style={style}>
               {visibleColumns.map((item, index) => {
                  let cellValue;
                  switch (item.defName) {
                     case 'serialno':
                        cellValue = row.serialNo || '-';
                        break;
                     case 'billno':
                        cellValue = `${row.prefix || ''}${row.DocNo || ''}${row.postFix || ''}` || '-';
                        break;
                     case 'date':
                        cellValue = formatDate(row.txnDate);
                        break;
                     case 'party':
                        cellValue = row.salesAccountName || '-';
                        break;
                     case 'itemname':
                        cellValue = row.itemName || '-';
                        break;
                     case 'saleprice':
                        cellValue =
                           row.saleprice === undefined || row.saleprice === null ? (
                              '-'
                           ) : (
                              <FormattedNumber value={row.saleprice} />
                           );
                        break;
                     case 'purchaseprice':
                        cellValue =
                           row.purchaseprice === undefined || row.purchaseprice === null ? (
                              '-'
                           ) : (
                              <FormattedNumber value={row.purchaseprice} />
                           );
                        break;
                     case 'expenseprice':
                        cellValue =
                           row.expenseprice === undefined || row.expenseprice === null ? (
                              '-'
                           ) : (
                              <FormattedNumber value={row.expenseprice} />
                           );
                        break;
                     case 'profit':
                        cellValue =
                           row.Profit === undefined || row.Profit === null ? (
                              '-'
                           ) : (
                              <FormattedNumber value={row.Profit} />
                           );
                        break;
                     case 'loss':
                        cellValue =
                           row.Loss === undefined || row.Loss === null ? (
                              '-'
                           ) : (
                              <FormattedNumber value={row.Loss} />
                           );
                        break;

                     default:
                        cellValue = '-';
                  }

                  const cellClasses = `
                     py-2 px-3 text-xs
                     ${item.isBold ? 'font-bold' : 'font-normal'}
                     ${item.isItalic ? 'italic' : 'not-italic'}
                     ${item.defName === 'amt' ? 'text-right' : 'text-left'}
                     ${isDark ? 'text-gray-200' : 'text-gray-800'}
                  `;

                  return (
                     <td
                        key={index}
                        className={cellClasses}
                        style={{ color: convertBackendColor(item.color) || (isDark ? '#e5e7eb' : '#1f2937') }}>
                        {cellValue}
                     </td>
                  );
               })}
            </tr>
         );
      } else {
         return (
            <tr key={`row-${row.docid}`} className={rowClasses} onClick={() => handledata(row)} style={style}>
               <td className={`py-0 px-3 text-xs w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {formatDate(row.txnDate)}
               </td>
               <td className={`py-0 px-3 text-xs w-24 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {`${row.prefix || ''}${row.DocNo || ''}${row.postFix || ''}` || '-'}
               </td>
               <td className={`py-0 px-3 text-xs w-64 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {row.salesAccountName || '-'}
               </td>
               <td className={`py-0 px-3 text-xs w-96 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {row.itemName || '-'}
               </td>
               <td
                  className={`py-0 px-3 text-xs w-48 overflow-hidden text-ellipsis whitespace-normal lg:whitespace-nowrap ${isDark ? 'text-gray-200' : 'text-gray-800'
                     }`}>
                  {row.serialNo || '-'}
               </td>
               <td className={`py-0 px-3 text-xs text-right w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {row.saleprice === undefined || row.saleprice === null ? (
                     '-'
                  ) : (
                     <FormattedNumber value={row.saleprice} />
                  )}
               </td>
               <td className={`py-0 px-3 text-xs text-right w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {row.purchaseprice === undefined || row.purchaseprice === null ? (
                     '-'
                  ) : (
                     <FormattedNumber value={row.purchaseprice} />
                  )}
               </td>
               <td className={`py-0 px-3 text-xs text-right w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {row.expenseprice === undefined || row.expenseprice === null ? (
                     '-'
                  ) : (
                     <FormattedNumber value={row.expenseprice} />
                  )}
               </td>
               <td className={`py-0 px-3 text-xs text-right w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {(row.Profit ?? row.profit) === undefined || (row.Profit ?? row.profit) === null ? (
                     '-'
                  ) : (
                     <FormattedNumber value={row.Profit ?? row.profit} />
                  )}
               </td>
               <td className={`py-0 px-3 text-xs text-right w-32 ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                  {(row.Loss ?? row.loss) === undefined || (row.Loss ?? row.loss) === null ? (
                     '-'
                  ) : (
                     <FormattedNumber value={row.Loss ?? row.loss} />
                  )}
               </td>
            </tr>
         );
      }
   },
);

// Utility functions
const calculateCompanyTotals = (daybooks) => {
   if (!daybooks || !Array.isArray(daybooks)) {
      return {
         totalSalePrice: 0,
         totalPurchasePrice: 0,
         totalExpensePrice: 0,
         totalProfit: 0,
         totalLoss: 0,
      };
   }

   return daybooks.reduce(
      (totals, daybook) => {
         const daybookTotals = calculateDaybookTotals(daybook.data);
         return {
            totalSalePrice: totals.totalSalePrice + daybookTotals.totalSalePrice,
            totalPurchasePrice: totals.totalPurchasePrice + daybookTotals.totalPurchasePrice,
            totalExpensePrice: totals.totalExpensePrice + daybookTotals.totalExpensePrice,
            totalProfit: totals.totalProfit + daybookTotals.totalProfit,
            totalLoss: totals.totalLoss + daybookTotals.totalLoss,
         };
      },
      {
         totalSalePrice: 0,
         totalPurchasePrice: 0,
         totalExpensePrice: 0,
         totalProfit: 0,
         totalLoss: 0,
      },
   );
};

const calculateDaybookTotals = (data) => {
   if (!data || !Array.isArray(data)) {
      return {
         totalSalePrice: 0,
         totalPurchasePrice: 0,
         totalExpensePrice: 0,
         totalProfit: 0,
         totalLoss: 0,
      };
   }

   return data.reduce(
      (totals, row) => ({
         totalSalePrice: totals.totalSalePrice + (row.saleprice || 0),
         totalPurchasePrice: totals.totalPurchasePrice + (row.purchaseprice || 0),
         totalExpensePrice: totals.totalExpensePrice + (row.expenseprice || 0),
         totalProfit: totals.totalProfit + (row.Profit || row.profit || 0), // Check both cases
         totalLoss: totals.totalLoss + (row.Loss || row.loss || 0), // Check both cases
      }),
      {
         totalSalePrice: 0,
         totalPurchasePrice: 0,
         totalExpensePrice: 0,
         totalProfit: 0,
         totalLoss: 0,
      },
   );
};

const formatDate = (dateString) => {
   if (!dateString) return '-';
   try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
   } catch (e) {
      return dateString;
   }
};

const columnsReportsLedgerDetail = [
   { id: 'txnDate', header: 'Date', accessor: 'txnDate' },
   { id: 'DocNo', header: 'Bill No', accessor: 'DocNo' },
   { id: 'salesAccountName', header: 'Party', accessor: 'salesAccountName' },
   { id: 'itemName', header: 'Item Name', accessor: 'itemName' },
   { id: 'serialNo', header: 'Serial No#', accessor: 'serialNo' },
   { id: 'saleprice', header: 'Sale Rate', accessor: 'saleprice' },
   { id: 'quantity1', header: 'Qty1', accessor: 'quantity1' },
   { id: 'quantity2', header: 'Qty2', accessor: 'quantity2' },
   { id: 'quantity3', header: 'Qty3', accessor: 'quantity3' },
   { id: 'purchaseprice', header: 'Avg. Prch. Rate', accessor: 'purchaseprice' },
   { id: 'Profit', header: 'Profit', accessor: 'Profit' },
   { id: 'Loss', header: 'Loss', accessor: 'Loss' },
];

const OverallGrandTotalHeader = memo(({ totals, isDark, visibleColumns }) => {
   if (!totals) return null;

   const bgGradient = isDark ? 'linear-gradient(135deg, #2D2A14 0%, #3F3A1A 100%)' : 'linear-gradient(135deg, #FEFCE8 0%, #FFFBEB 100%)';
   const borderColor = isDark ? '#CA8A04' : '#A16207';
   const textColor = isDark ? '#FDE047' : '#713F12';
   const netProfit = totals.totalProfit - Math.abs(totals.totalLoss);
   const netProfitColor = netProfit >= 0 ? '#16a34a' : '#dc2626';

   const getValue = (defName) => ({
      saleprice: totals.totalSalePrice,
      purchaseprice: totals.totalPurchasePrice,
      expenseprice: totals.totalExpensePrice,
      profit: totals.totalProfit,
      loss: totals.totalLoss,
   }[defName] ?? 0);

   const numericKeys = ['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss'];

   // ── DYNAMIC layout ──────────────────────────────────────────────
   if (visibleColumns) {
      const firstNumIdx = visibleColumns.findIndex(c => numericKeys.includes(c.defName));

      return (
         <tr style={{ background: bgGradient, borderLeft: `4px solid ${borderColor}` }}>
            {/* Name cell - spans all cols before first numeric */}
            <td colSpan={firstNumIdx} style={{ padding: '10px 12px' }}>
               <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                     <span style={{ fontWeight: 800, fontSize: '13px', letterSpacing: '0.5px', color: textColor }}>
                        OVERALL GRAND TOTAL
                     </span>
                     <span style={{ background: '#3B82F6', color: '#fff', fontSize: '11px', fontWeight: 700, padding: '1px 8px', borderRadius: '999px' }}>
                        {totals.companyCount} {totals.companyCount === 1 ? 'Company' : 'Companies'}
                     </span>
                  </div>
                  <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                     (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
                  </span>
               </div>
            </td>

            {/* Numeric cols */}
            {visibleColumns.filter(c => numericKeys.includes(c.defName)).map((col, ci) => (
               <td key={ci} style={{ padding: '10px 12px', textAlign: 'right' }}>
                  {ci === 0 && (
                     <div style={{ fontSize: '11px', fontWeight: 700, color: textColor, marginBottom: '2px' }}>
                        Total:
                     </div>
                  )}
                  <FormattedNumberForGrandTotal value={getValue(col.defName)} />
               </td>
            ))}

            {/* Chevron placeholder */}
            <td style={{ width: '48px' }} />
         </tr>
      );
   }

   return (
      <tr style={{ background: bgGradient, borderLeft: `4px solid ${borderColor}` }}>
         {/* Span Date + BillNo + Party = cols 0-2 */}
         <td colSpan={3} style={{ padding: '10px 12px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
               <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontWeight: 800, fontSize: '13px', letterSpacing: '0.5px', color: textColor }}>
                     OVERALL GRAND TOTAL
                  </span>
                  <span style={{ background: '#3B82F6', color: '#fff', fontSize: '11px', fontWeight: 700, padding: '1px 8px', borderRadius: '999px' }}>
                     {totals.companyCount} {totals.companyCount === 1 ? 'Company' : 'Companies'}
                  </span>
               </div>
               <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                  (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
               </span>
            </div>
         </td>
         {/* ItemName col - empty */}
         <td />
         {/* SerialNo col - "Total:" label */}
         <td style={{ padding: '10px 12px', textAlign: 'right', fontWeight: 700, color: textColor }}>Total:</td>
         {/* Numeric cols */}
         <td style={{ padding: '10px 12px', textAlign: 'right' }}><FormattedNumberForGrandTotal value={totals.totalSalePrice} /></td>
         <td style={{ padding: '10px 12px', textAlign: 'right' }}><FormattedNumberForGrandTotal value={totals.totalPurchasePrice} /></td>
         <td style={{ padding: '10px 12px', textAlign: 'right' }}><FormattedNumberForGrandTotal value={totals.totalExpensePrice} /></td>
         <td style={{ padding: '10px 12px', textAlign: 'right' }}><FormattedNumberForGrandTotal value={totals.totalProfit} /></td>
         <td style={{ padding: '10px 12px', textAlign: 'right' }}><FormattedNumberForGrandTotal value={totals.totalLoss} /></td>
         {/* Chevron placeholder */}
         <td />
      </tr>
   );
});


const VirtualizedTable = memo(({
   data, isLoading, expandedItems, toggleExpand, textColor, borderColor,
   setIsOpenPurchaseReturnSingleView, setEntityType, setIsOpenSingleViewinr,
   dynamicOptionValues, containerHeight = 600, calculateOverallGrandTotals,
}) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const listRef = useRef(null);
   const rowHeights = useRef({});

   // ✅ visibleColumns at top level - fixes the hook error
   const visibleColumns = useMemo(() => {
      if (dynamicOptionValues?.formatData?.viewJson) {
         return dynamicOptionValues.formatData.viewJson
            .filter(item => item.isShow === true || item.isShow === 'true')
            .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));
      }
      return null; // null = use static layout
   }, [dynamicOptionValues]);

   // ✅ colgroup matching exact column widths - for static layout
   const StaticColGroup = () => (
      <colgroup>
         <col style={{ width: '128px' }} /> {/* Date */}
         <col style={{ width: '96px' }} />  {/* Bill No */}
         <col style={{ width: '256px' }} /> {/* Party */}
         <col style={{ width: '384px' }} /> {/* Item Name */}
         <col style={{ width: '192px' }} /> {/* Serial No */}
         <col style={{ width: '128px' }} /> {/* Sale Price */}
         <col style={{ width: '128px' }} /> {/* Purchase Price */}
         <col style={{ width: '128px' }} /> {/* Expense Price */}
         <col style={{ width: '128px' }} /> {/* Profit */}
         <col style={{ width: '128px' }} /> {/* Loss */}
         <col style={{ width: '48px' }} />  {/* Chevron */}
      </colgroup>
   );

   // ✅ Dynamic colgroup from visibleColumns
   const DynamicColGroup = () => (
      <colgroup>
         {visibleColumns.map((col, i) => (
            <col key={i} style={{ width: `${(parseFloat(col.flex) || 1) * 100}px` }} />
         ))}
         <col style={{ width: '48px' }} /> {/* Chevron */}
      </colgroup>
   );

   const getTotalItemCount = useCallback(() => {
      if (isLoading) return 1;
      if (!data || data.length === 0) return 1;
      let count = 0;
      const grandTotals = calculateOverallGrandTotals();
      if (grandTotals) count++;
      data.forEach((company) => {
         count++;
         if (expandedItems[`company-${company.companyId}`]) {
            company.daybook?.forEach((daybook) => {
               count++;
               if (expandedItems[`account-${daybook.daybookId}`]) {
                  count++;
                  count += daybook.data?.length || 0;
               }
            });
         }
      });
      return count;
   }, [data, expandedItems, isLoading, calculateOverallGrandTotals]);

   const getItemHeight = useCallback((index) => {
      if (rowHeights.current[index]) return rowHeights.current[index];
      const grandTotals = calculateOverallGrandTotals();
      if (index === 0 && grandTotals) return 80;
      if (isLoading) return ROW_HEIGHTS.LOADING_ROW;
      if (!data || data.length === 0) return ROW_HEIGHTS.NO_DATA_ROW;
      let currentIndex = grandTotals ? 1 : 0;
      for (let i = 0; i < data.length; i++) {
         const company = data[i];
         const companyKey = `company-${company.companyId}`;
         if (currentIndex === index) { rowHeights.current[index] = ROW_HEIGHTS.COMPANY_HEADER; return ROW_HEIGHTS.COMPANY_HEADER; }
         currentIndex++;
         if (expandedItems[companyKey]) {
            for (let j = 0; j < company.daybook?.length; j++) {
               const daybook = company.daybook[j];
               const daybookKey = `account-${daybook.daybookId}`;
               if (currentIndex === index) { rowHeights.current[index] = ROW_HEIGHTS.DAYBOOK_HEADER; return ROW_HEIGHTS.DAYBOOK_HEADER; }
               currentIndex++;
               if (expandedItems[daybookKey]) {
                  if (currentIndex === index) { rowHeights.current[index] = ROW_HEIGHTS.DAYBOOK_HEADER; return ROW_HEIGHTS.DAYBOOK_HEADER; }
                  currentIndex++;
                  for (let k = 0; k < (daybook.data?.length || 0); k++) {
                     if (currentIndex === index) { rowHeights.current[index] = ROW_HEIGHTS.TRANSACTION_ROW; return ROW_HEIGHTS.TRANSACTION_ROW; }
                     currentIndex++;
                  }
               }
            }
         }
      }
      return ROW_HEIGHTS.TRANSACTION_ROW;
   }, [data, expandedItems, isLoading, calculateOverallGrandTotals]);

   useEffect(() => {
      rowHeights.current = {};
      if (listRef.current) listRef.current.resetAfterIndex(0);
   }, [data, expandedItems, isLoading]);

   const Row = useCallback(({ index, style }) => {
      const grandTotals = calculateOverallGrandTotals();

      // Grand total
      if (index === 0 && grandTotals) {
         return (
            <div style={style}>
               <table style={{ width: '100%', tableLayout: 'fixed' }}>
                  {visibleColumns ? <DynamicColGroup /> : <StaticColGroup />}
                  <tbody>
                     <OverallGrandTotalHeader totals={grandTotals} isDark={isDark} visibleColumns={visibleColumns} />
                  </tbody>
               </table>
            </div>
         );
      }

      if (isLoading) {
         return (
            <div style={style}>
               <table style={{ width: '100%', tableLayout: 'fixed' }}>
                  <tbody>
                     <tr><td colSpan={12} style={{ textAlign: 'center', padding: '40px' }}><Loader /></td></tr>
                  </tbody>
               </table>
            </div>
         );
      }

      if (!data || data.length === 0) {
         return (
            <div style={style}>
               <table style={{ width: '100%', tableLayout: 'fixed' }}>
                  <tbody>
                     <tr><td colSpan={12} style={{ textAlign: 'center', padding: '40px' }}><Text>No data found</Text></td></tr>
                  </tbody>
               </table>
            </div>
         );
      }

      let currentIndex = grandTotals ? 1 : 0;

      for (let i = 0; i < data.length; i++) {
         const company = data[i];
         const companyKey = `company-${company.companyId}`;

         // ✅ Company header
         if (currentIndex === index) {
            const companyTotals = calculateCompanyTotals(company.daybook);
            const netProfit = companyTotals.totalProfit - Math.abs(companyTotals.totalLoss);
            const netProfitColor = netProfit >= 0 ? '#16a34a' : '#dc2626';
            const bgClass = isDark ? 'bg-purple-900/40 text-gray-100' : 'bg-blue-50 text-gray-900';

            return (
               <div style={style}>
                  <table style={{ width: '100%', tableLayout: 'fixed' }}>
                     {visibleColumns ? <DynamicColGroup /> : <StaticColGroup />}
                     <tbody>
                        <tr className={`cursor-pointer ${bgClass}`} onClick={() => toggleExpand(companyKey)}>
                           {visibleColumns ? (
                              <>
                                 {/* Dynamic: span all non-numeric cols */}
                                 <td colSpan={visibleColumns.findIndex(c => ['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss'].includes(c.defName))} className="py-3 px-4">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                       <span style={{ fontWeight: 700 }}>{company.companyName}</span>
                                       <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                                          (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
                                       </span>
                                    </div>
                                 </td>
                                 {visibleColumns.filter(c => ['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss'].includes(c.defName)).map((col, ci, arr) => (
                                    <td key={ci} className="py-0 px-2 text-right">
                                       {ci === 0 && <span style={{ fontWeight: 700, marginRight: 8 }}>Total:</span>}
                                       <FormattedNumberForGrandTotal value={
                                          col.defName === 'saleprice' ? companyTotals.totalSalePrice :
                                             col.defName === 'purchaseprice' ? companyTotals.totalPurchasePrice :
                                                col.defName === 'expenseprice' ? companyTotals.totalExpensePrice :
                                                   col.defName === 'profit' ? companyTotals.totalProfit :
                                                      companyTotals.totalLoss
                                       } />
                                    </td>
                                 ))}
                                 <td className="py-0 px-2 text-right">{expandedItems[companyKey] ? <ChevronUpIcon /> : <ChevronDownIcon />}</td>
                              </>
                           ) : (
                              <>
                                 {/* Static: colSpan=3 covers Date+BillNo+Party */}
                                 <td colSpan={3} className="py-3 px-3">
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                       <span className={`font-bold text-base ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>{company.companyName}</span>
                                       <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                                          (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
                                       </span>
                                    </div>
                                 </td>
                                 <td className="py-3 px-3"></td>{/* Item Name - empty */}
                                 <td className={`py-3 px-3 text-right font-bold ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>Total:</td>
                                 <td className="py-3 px-3 text-right"><FormattedNumberForGrandTotal value={companyTotals.totalSalePrice} /></td>
                                 <td className="py-3 px-3 text-right"><FormattedNumberForGrandTotal value={companyTotals.totalPurchasePrice} /></td>
                                 <td className="py-3 px-3 text-right"><FormattedNumberForGrandTotal value={companyTotals.totalExpensePrice} /></td>
                                 <td className="py-3 px-3 text-right"><FormattedNumberForGrandTotal value={companyTotals.totalProfit} /></td>
                                 <td className="py-3 px-3 text-right"><FormattedNumberForGrandTotal value={companyTotals.totalLoss} /></td>
                                 <td className="py-3 px-3 text-right">{expandedItems[companyKey] ? <ChevronUpIcon /> : <ChevronDownIcon />}</td>
                              </>
                           )}
                        </tr>
                     </tbody>
                  </table>
               </div>
            );
         }
         currentIndex++;

         if (expandedItems[companyKey]) {
            for (let j = 0; j < company.daybook?.length; j++) {
               const daybook = company.daybook[j];
               const daybookKey = `account-${daybook.daybookId}`;

               // ✅ Daybook header
               if (currentIndex === index) {
                  const daybookTotals = calculateDaybookTotals(daybook.data);
                  const netProfit = daybookTotals.totalProfit - Math.abs(daybookTotals.totalLoss);
                  const netProfitColor = netProfit >= 0 ? '#16a34a' : '#dc2626';
                  const bgClass = isDark ? 'bg-indigo-900/40 text-gray-100' : 'bg-amber-50 text-gray-900';

                  return (
                     <div style={style}>
                        <table style={{ width: '100%', tableLayout: 'fixed' }}>
                           {visibleColumns ? <DynamicColGroup /> : <StaticColGroup />}
                           <tbody>
                              <tr className={`cursor-pointer ${bgClass}`} onClick={() => toggleExpand(daybookKey)}>
                                 {visibleColumns ? (
                                    <>
                                       <td colSpan={visibleColumns.findIndex(c => ['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss'].includes(c.defName))} className="py-2 px-3 pl-8">
                                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                                             <span style={{ fontWeight: 600, fontSize: '13px' }}>{daybook.daybookName}</span>
                                             <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                                                (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
                                             </span>
                                          </div>
                                       </td>
                                       {visibleColumns.filter(c => ['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss'].includes(c.defName)).map((col, ci) => (
                                          <td key={ci} className="py-0 px-2 text-right">
                                             {ci === 0 && <span style={{ fontWeight: 700, marginRight: 8 }}>Total:</span>}
                                             <FormattedNumberForGrandTotal value={
                                                col.defName === 'saleprice' ? daybookTotals.totalSalePrice :
                                                   col.defName === 'purchaseprice' ? daybookTotals.totalPurchasePrice :
                                                      col.defName === 'expenseprice' ? daybookTotals.totalExpensePrice :
                                                         col.defName === 'profit' ? daybookTotals.totalProfit :
                                                            daybookTotals.totalLoss
                                             } />
                                          </td>
                                       ))}
                                       <td className="py-0 px-2 text-right">{expandedItems[daybookKey] ? <ChevronUpIcon /> : <ChevronDownIcon />}</td>
                                    </>
                                 ) : (
                                    <>
                                       <td colSpan={4} className="py-2 px-3 w-96 pl-8">
                                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                                             <span className={`font-semibold text-sm ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>{daybook.daybookName}</span>
                                             <span style={{ fontSize: '11px', fontWeight: 600, color: netProfitColor }}>
                                                (Net Profit: ₹{netProfit.toLocaleString('en-IN', { minimumFractionDigits: 2 })})
                                             </span>
                                          </div>
                                       </td>
                                       {/* <td className="py-2 px-3 w-32"></td> */}
                                       {/* <td className="py-2 px-3 w-24"></td> */}
                                       {/* <td className="py-2 px-3 w-64"></td> */}
                                       <td className={`py-2 px-3 w-48 text-right font-bold text-sm ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>Total:</td>
                                       <td className="py-2 px-3 w-32 text-right"><FormattedNumberForGrandTotal value={daybookTotals.totalSalePrice} /></td>
                                       <td className="py-2 px-3 w-32 text-right"><FormattedNumberForGrandTotal value={daybookTotals.totalPurchasePrice} /></td>
                                       <td className="py-2 px-3 w-32 text-right"><FormattedNumberForGrandTotal value={daybookTotals.totalExpensePrice} /></td>
                                       <td className="py-2 px-3 w-32 text-right"><FormattedNumberForGrandTotal value={daybookTotals.totalProfit} /></td>
                                       <td className="py-2 px-3 w-32 text-right"><FormattedNumberForGrandTotal value={daybookTotals.totalLoss} /></td>
                                       <td className="py-2 px-3 text-right">{expandedItems[daybookKey] ? <ChevronUpIcon /> : <ChevronDownIcon />}</td>
                                    </>
                                 )}
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  );
               }
               currentIndex++;

               if (expandedItems[daybookKey]) {
                  // ✅ Column header
                  if (currentIndex === index) {
                     const headerClasses = `sticky top-0 z-2 border-t ${isDark ? 'bg-gray-900 text-gray-100 border-gray-700' : 'bg-gray-100 text-gray-900 border-gray-300'}`;
                     return (
                        <div style={style}>
                           <table style={{ width: '100%', tableLayout: 'fixed' }}>
                              {visibleColumns ? <DynamicColGroup /> : <StaticColGroup />}
                              <tbody>
                                 <tr className={headerClasses}>
                                    {visibleColumns ? (
                                       <>
                                          {visibleColumns.map((col, idx) => (
                                             <td key={idx} className={`py-2 px-3 text-xs font-bold ${['saleprice', 'purchaseprice', 'expenseprice', 'profit', 'loss', 'amt'].includes(col.defName) ? 'text-right' : 'text-left'} ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>
                                                {col.title || col.defName}
                                             </td>
                                          ))}
                                          <td></td>
                                       </>
                                    ) : (
                                       <>
                                          <td className="py-2 px-3 text-sm font-bold w-32">Date</td>
                                          <td className="py-2 px-3 text-sm font-bold w-24">Bill No</td>
                                          <td className="py-2 px-3 text-sm font-bold w-64">Party</td>
                                          <td className="py-2 px-3 text-sm font-bold w-96">Item Name</td>
                                          <td className="py-2 px-3 text-sm font-bold w-48">Serial No#</td>
                                          <td className="py-2 px-3 text-sm font-bold text-right w-32">Sale Price</td>
                                          <td className="py-2 px-3 text-sm font-bold text-right w-32">Purchase Price</td>
                                          <td className="py-2 px-3 text-sm font-bold text-right w-32">Expense Price</td>
                                          <td className="py-2 px-3 text-sm font-bold text-right w-32">Profit</td>
                                          <td className="py-2 px-3 text-sm font-bold text-right w-32">Loss</td>
                                          <td></td>
                                       </>
                                    )}
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     );
                  }
                  currentIndex++;

                  // ✅ Transaction rows
                  for (let k = 0; k < (daybook.data?.length || 0); k++) {
                     if (currentIndex === index) {
                        const row = daybook.data[k];
                        return (
                           <div style={style}>
                              <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                 {visibleColumns ? <DynamicColGroup /> : <StaticColGroup />}
                                 <tbody>
                                    <DataRow
                                       row={row}
                                       isOddRow={k % 2 !== 0}
                                       borderColor={borderColor}
                                       formatDate={formatDate}
                                       setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                                       setEntityType={setEntityType}
                                       setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                                       dynamicOptionValues={dynamicOptionValues}
                                       viewJson={dynamicOptionValues?.formatData?.viewJson}
                                    />
                                 </tbody>
                              </table>
                           </div>
                        );
                     }
                     currentIndex++;
                  }
               }
            }
         }
      }
      return null;
   }, [data, isLoading, expandedItems, toggleExpand, borderColor, isDark,
      dynamicOptionValues, visibleColumns, calculateOverallGrandTotals,
      setIsOpenSingleViewinr, setEntityType, setIsOpenPurchaseReturnSingleView]);

   return (
      <div style={{ height: `${containerHeight}px`, width: '100%' }}>
         <VariableSizeList ref={listRef} height={containerHeight} width="100%" itemCount={getTotalItemCount()} itemSize={getItemHeight} overscanCount={5}>
            {Row}
         </VariableSizeList>
      </div>
   );
});

const BillToBillProfit = () => {
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();
   const textColor = useColorModeValue('black', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const { companyList } = useGlobal();
   const { userGlobalSettingsData } = useGlobal();
   const accounts = useSelector((state) => state.account.list || []);
   const [allExpanded, setAllExpanded] = useState(false);
   const dbName = localStorage.getItem('dbName');
   const fromDateInputRef = useRef(null);
   const lastKeyPressed = useRef('');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const keyPressTimeoutRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [companyFilter, setCompanyFilter] = useState([]);
   const [fromDate, setFromDate] = useState(null);
   const [accountId, setAccountId] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [searchQuery, setSearchQuery] = useState('');
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 30);
      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });
   const [isLoading, setIsLoading] = useState(false);
   const [expandedItems, setExpandedItems] = useState({});
   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRenderFilter = useRef(true);
   // report format
   const reportformat = useSelector((state) => state.reports?.reportFormat || []);
   const [reportType, setReportType] = useState('Default');
   const [editData, setEditData] = useState({});
   const [isEditShowHide, setIsEditShowHide] = useState(false);
   const [isShowHideColumn, setIsShowHideColumn] = useState(false);
   const [showHideData, setShowHideData] = useState({});
   const [formatType, setFormatType] = useState('Default');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const allowedDefNames = ['Bill To Bill Profit'];
   const dynamicOptions = reportformat
      .filter((item) => item?.defName && allowedDefNames.includes(item?.defName))
      .map((item) => ({
         id: item.id,
         value: item.defName && item.title,
         label: item.title,
         isDynamic: true,
         formatData: item,
      }));
   const dynamicOptionValues = dynamicOptions.find((option) => option.value === reportType);
   const isStaticReportType = ['Default'].includes(reportType);
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;
   const saleInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.saleinvoice
      : null;
   const saleReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.salereturn
      : null;
   const purchaseInvoiceRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchaseinvoice
      : null;
   const purchaseReturnRight = Array.isArray(userRights)
      ? userRights.find((right) => right.companyId === companyId)?.purchasereturn
      : null;
   const [entityType, setEntityType] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') {
         return state?.receiveInventory?.single || {};
      } else if (entityType === 'issuemaster') {
         return state?.issueInventory?.single || {};
      } else {
         return {};
      }
   });
   const account = useSelector((state) => state.account.single);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);
   const { viewDetail, paginate } = useMemo(() => {
      const data = entityType === 'saleinvoice' ? viewDatasi : entityType === 'purchaseinvoice' ? viewDatapi : null;

      const pagination =
         entityType === 'saleinvoice'
            ? viewDatasi?.pagination
            : entityType === 'purchaseinvoice'
               ? viewDatapi?.pagination
               : null;

      return { viewDetail: data, paginate: pagination };
   }, [viewDatasi, viewDatapi]);

   const dispatch = useDispatch();
   const BillToBillProfit = useSelector((state) => {
      const billToBillData = state.reports.billToBillProfit || [];
      return billToBillData.map((company) => ({
         ...company,
         daybook: company.data || [],
      }));
   });

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const accountOptions = useMemo(
      () =>
         accounts.map((account) => ({
            value: account.id,
            label: account.name,
         })),
      [accounts],
   );

   const fetchReportType = useCallback(async () => {
      await dispatch(getReportFormat());
   }, [dispatch]);

   useEffect(() => {
      if (isFirstRenderFilter.current) {
         isFirstRenderFilter.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [BillToBillProfit]);

   // Debounced search effect
   useEffect(() => {
      fetchReportType();
   }, [fetchReportType]);

   // Initialize expanded state
   useEffect(() => {
      if (BillToBillProfit && BillToBillProfit.length > 0 && Object.keys(expandedItems).length === 0) {
         const initialExpandedState = {};
         BillToBillProfit.forEach((companyData, companyIndex) => {
            const companyKey = `company-${companyData.companyId || companyIndex}`;
            initialExpandedState[companyKey] = true;

            if (companyData.daybook && Array.isArray(companyData.daybook)) {
               companyData.daybook.forEach((daybookData, daybookIndex) => {
                  const daybookKey = `account-${daybookData.daybookId || daybookIndex}`;
                  initialExpandedState[daybookKey] = true;
               });
            }
         });
         setExpandedItems(initialExpandedState);
      }
   }, [BillToBillProfit]);

   // Initialize fromDate
   useEffect(() => {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 1);
      const formattedDate = today.toISOString().split('T')[0];
      setFromDate(formattedDate);
   }, []);

   // Initialize company filter
   useEffect(() => {
      const storedCompanyId = localStorage.getItem('companyId');
      if (storedCompanyId && companyList?.length > 0) {
         const companyId = parseInt(storedCompanyId);
         const matchingCompany = companyList?.find((comp) => comp.id === companyId);
         if (matchingCompany) {
            setCompanyFilter([matchingCompany.id]);
         }
      }
   }, [companyList]);

   // Debounced search
   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 300);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   // Fetch data
   const fetchData = useCallback(
      debounce(async () => {
         try {
            setIsLoading(true);
            dispatch(clearCacheReport());

            if (!dateRange || !fromDate || !toDate) {
               console.warn('Missing required date parameters');
               return;
            }

            const validCompanyIds =
               companyFilter.length > 0
                  ? companyFilter
                  : localStorage.getItem('companyId')
                     ? [parseInt(localStorage.getItem('companyId'))]
                     : [];

            if (validCompanyIds.length === 0 || validCompanyIds.some(isNaN)) {
               console.error('Invalid company IDs');
               return;
            }

            const params = {
               companyIds: validCompanyIds.join(','),
               fromDate: dateRange.fromDate,
               toDate: dateRange.toDate,
               search: debouncedSearchQuery,
            };

            await dispatch(getBillToBillProfit(params));
         } catch (error) {
            console.error('Error fetching bill-to-bill profit:', error);
         } finally {
            setIsLoading(false);
         }
      }, 500),
      [dispatch, companyFilter, fromDate, toDate, debouncedSearchQuery, dateRange],
   );

   useEffect(() => {
      fetchData();
      return () => fetchData.cancel();
   }, [fetchData]);

   // Event handlers
   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));
      setDateRange({ fromDate: from, toDate: to });
   }, []);

   const handleSearchChange = useCallback((e) => {
      const value = e.target.value;
      setSearchQuery(value);
   }, []);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({
         ...prev,
         [id]: !prev[id],
      }));
   }, []);

   const handleRefresh = useCallback(() => {
      fetchData();
   }, [fetchData]);

   const handleCompanyChange = useCallback((selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   }, []);

   const handleAccountChange = useCallback((selectedOption) => {
      setAccountId(selectedOption ? selectedOption.value : null);
   }, []);

   const expandAll = useCallback(() => {
      const newExpanded = {};
      BillToBillProfit.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.daybook) {
            companyData.daybook.forEach((itemData) => {
               const itemKey = `account-${itemData.daybookId}`;
               newExpanded[itemKey] = true;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(true);
   }, [BillToBillProfit]);

   const collapseAll = useCallback(() => {
      const newExpanded = {};
      BillToBillProfit.forEach((companyData) => {
         const companyKey = `company-${companyData.companyId}`;
         newExpanded[companyKey] = true;

         if (companyData.daybook) {
            companyData.daybook.forEach((itemData) => {
               const itemKey = `account-${itemData.daybookId}`;
               newExpanded[itemKey] = false;
            });
         }
      });
      setExpandedItems(newExpanded);
      setAllExpanded(false);
   }, [BillToBillProfit]);

   // Keyboard shortcuts
   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === '.') {
            if (lastKeyPressed.current === '.' && keyPressTimeoutRef.current) {
               const today = new Date();
               const todayFormatted = today.toISOString().split('T')[0];
               setToDate(todayFormatted);

               const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
               const firstDayFormatted = firstDay.toISOString().split('T')[0];
               setFromDate(firstDayFormatted);

               clearTimeout(keyPressTimeoutRef.current);
               keyPressTimeoutRef.current = null;
               lastKeyPressed.current = '';
            } else {
               lastKeyPressed.current = '.';

               if (keyPressTimeoutRef.current) {
                  clearTimeout(keyPressTimeoutRef.current);
               }

               keyPressTimeoutRef.current = setTimeout(() => {
                  lastKeyPressed.current = '';
                  keyPressTimeoutRef.current = null;
               }, 500);
            }
         } else {
            lastKeyPressed.current = '';
            if (keyPressTimeoutRef.current) {
               clearTimeout(keyPressTimeoutRef.current);
               keyPressTimeoutRef.current = null;
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
         if (keyPressTimeoutRef.current) {
            clearTimeout(keyPressTimeoutRef.current);
         }
      };
   }, []);

   // Outside click for search
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const companyIds = useMemo(
      () =>
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [],
      [companyFilter],
   );

   const handleViewSingleData = async (id) => {
      await dispatch(getReceiveInventory(id));
      setIsOpenSingleViewinr(true);
   };

   const handleSalesSingleDataViewClose = () => {
      setIsOpenSingleViewinr();
   };

   const handleNextPage = () => {
      console.log('Next');
   };
   const handlePrevPage = () => {
      console.log('Prev');
   };

   const deletePurchaseReturn = () => {
      if (entityType === 'purchasereturn') {
         deleteRecord(
            viewDetail?.id,
            deletePurchaseReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'salereturn') {
         deleteRecord(
            viewDetail?.id,
            deleteSaleReturnInvoice,
            dispatch,
            user?.loginhistory?.companyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'saleinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deleteSaleInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      if (entityType === 'purchaseinvoice') {
         deleteRecordForSales(
            viewDetail?.id,
            viewDetail?.daybookId,
            viewDetail?.accountId,
            deletePurchaseInvoice,
            dispatch,
            storedCompanyId,
            userGlobalSettingsData,
         );
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => {
      setIsOpenPurchaseReturnSingleView();
   };

   useEffect(() => {
      if (account) {
         const details = [
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ];
         setDynamicUserDetails(details);
      }
   }, [account]);

   const getColumnsReportsSalesDetail = (reportType) => {
      const viewJson = dynamicOptionValues?.formatData?.viewJson || [];

      const convertBackendColor = (backendColor) => {
         if (!backendColor) return null;
         if (backendColor.startsWith('#')) return backendColor;
         if (backendColor.startsWith('0xff')) return '#' + backendColor.substring(4);
         if (/^[0-9A-Fa-f]{6}$/.test(backendColor)) return '#' + backendColor;
         return backendColor;
      };

      const getColumnInfo = (defName) => {
         const viewItem = viewJson.find(
            (item) =>
               item?.defName?.toLowerCase() === defName.toLowerCase() ||
               item?.title?.toLowerCase() === defName.toLowerCase(),
         );

         if (!viewItem || isStaticReportType) {
            return {
               title: defName,
               isShow: true,
               color: textColor,
               isBold: false,
               isItalic: false,
               orderNo: 0,
               flex: 1,
            };
         }

         return {
            title: viewItem.title || defName,
            isShow: viewItem.isShow === 'true' || viewItem.isShow === true,
            color: viewItem.color ? convertBackendColor(viewItem.color) : textColor,
            isBold: viewItem.isBold === 'true' || viewItem.isBold === true,
            isItalic: viewItem.isItalic === 'true' || viewItem.isItalic === true,
            orderNo: viewItem.orderNo ? parseInt(viewItem.orderNo) : 0,
            flex: viewItem.flex ? parseInt(viewItem.flex) : 1,
         };
      };

      const baseColumns = [
         {
            id: 'transactionAt',
            header: getColumnInfo('date').title,
            accessor: 'transactionAt',
            isShow: getColumnInfo('date').isShow,
            color: getColumnInfo('date').color,
            isBold: getColumnInfo('date').isBold,
            isItalic: getColumnInfo('date').isItalic,
            orderNo: getColumnInfo('date').orderNo,
            flex: getColumnInfo('date').flex,
            cell: (info) => {
               const value = info.getValue();
               return value ? moment(value).format('DD-MM-YYYY') : value;
            },
         },
         {
            id: 'Bill No',
            header: getColumnInfo('billno').title,
            accessor: 'Bill No',
            isShow: getColumnInfo('billno').isShow,
            color: getColumnInfo('billno').color,
            isBold: getColumnInfo('billno').isBold,
            isItalic: getColumnInfo('billno').isItalic,
            orderNo: getColumnInfo('billno').orderNo,
            flex: getColumnInfo('billno').flex,
         },
         {
            id: 'accountname',
            header: getColumnInfo('party').title,
            accessor: 'accountname',
            isShow: getColumnInfo('party').isShow,
            color: getColumnInfo('party').color,
            isBold: getColumnInfo('party').isBold,
            isItalic: getColumnInfo('party').isItalic,
            orderNo: getColumnInfo('party').orderNo,
            flex: getColumnInfo('party').flex,
         },
         {
            id: 'itemname',
            header: getColumnInfo('itemname').title,
            accessor: 'itemname',
            isShow: getColumnInfo('itemname').isShow,
            color: getColumnInfo('itemname').color,
            isBold: getColumnInfo('itemname').isBold,
            isItalic: getColumnInfo('itemname').isItalic,
            orderNo: getColumnInfo('itemname').orderNo,
            flex: getColumnInfo('itemname').flex,
         },
         {
            id: 'serialNo',
            header: getColumnInfo('serialNo').title,
            accessor: 'serialNo',
            isShow: getColumnInfo('serialNo').isShow,
            color: getColumnInfo('serialNo').color,
            isBold: getColumnInfo('serialNo').isBold,
            isItalic: getColumnInfo('serialNo').isItalic,
            orderNo: getColumnInfo('serialNo').orderNo,
            flex: getColumnInfo('serialNo').flex,
         },
         {
            id: 'Sale Price',
            header: getColumnInfo('saleprice').title,
            accessor: 'Sale Price',
            isNumeric: true,
            isShow: getColumnInfo('saleprice').isShow,
            color: getColumnInfo('saleprice').color,
            isBold: getColumnInfo('saleprice').isBold,
            isItalic: getColumnInfo('saleprice').isItalic,
            orderNo: getColumnInfo('saleprice').orderNo,
            flex: getColumnInfo('saleprice').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'Purchase Price',
            header: getColumnInfo('purchaseprice').title,
            accessor: 'Amount',
            isNumeric: true,
            isShow: getColumnInfo('purchaseprice').isShow,
            color: getColumnInfo('purchaseprice').color,
            isBold: getColumnInfo('purchaseprice').isBold,
            isItalic: getColumnInfo('purchaseprice').isItalic,
            orderNo: getColumnInfo('purchaseprice').orderNo,
            flex: getColumnInfo('purchaseprice').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'Expense Price',
            header: getColumnInfo('expenseprice').title,
            accessor: 'Amount',
            isNumeric: true,
            isShow: getColumnInfo('expenseprice').isShow,
            color: getColumnInfo('expenseprice').color,
            isBold: getColumnInfo('expenseprice').isBold,
            isItalic: getColumnInfo('expenseprice').isItalic,
            orderNo: getColumnInfo('expenseprice').orderNo,
            flex: getColumnInfo('expenseprice').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'Profit',
            header: getColumnInfo('Profit').title,
            accessor: 'Profit',
            isNumeric: true,
            isShow: getColumnInfo('Profit').isShow,
            color: getColumnInfo('Profit').color,
            isBold: getColumnInfo('Profit').isBold,
            isItalic: getColumnInfo('Profit').isItalic,
            orderNo: getColumnInfo('Profit').orderNo,
            flex: getColumnInfo('Profit').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString()}`;
            },
         },
         {
            id: 'Loss',
            header: getColumnInfo('Loss').title,
            accessor: 'Loss',
            isNumeric: true,
            isShow: getColumnInfo('Loss').isShow,
            color: getColumnInfo('Loss').color,
            isBold: getColumnInfo('Loss').isBold,
            isItalic: getColumnInfo('Loss').isItalic,
            orderNo: getColumnInfo('Loss').orderNo,
            flex: getColumnInfo('Loss').flex,
            cell: (info) => {
               const value = info.getValue();
               return `₹${Number(value || 0).toLocaleString}`
            }
         }
      ];

      return baseColumns
         .filter((col) => col.isShow !== false)
         .sort((a, b) => {
            const orderA = a.orderNo || 0;
            const orderB = b.orderNo || 0;
            return orderA - orderB;
         });
   };

   const calculateOverallGrandTotals = useCallback(() => {
      if (!BillToBillProfit || BillToBillProfit.length === 0 || companyFilter.length <= 1) {
         return null;
      }

      const overallTotals = {
         totalSalePrice: 0,
         totalPurchasePrice: 0,
         totalExpensePrice: 0,
         totalProfit: 0,
         totalLoss: 0,
         companyCount: companyFilter.length,
      };

      BillToBillProfit.forEach((companyData) => {
         if (!companyData.daybook) return;

         companyData.daybook.forEach((daybookData) => {
            if (!daybookData.data) return;

            daybookData.data.forEach((transaction) => {
               overallTotals.totalSalePrice += transaction.saleprice || 0;
               overallTotals.totalPurchasePrice += transaction.purchaseprice || 0;
               overallTotals.totalExpensePrice += transaction.expenseprice || 0;
               overallTotals.totalProfit += transaction.Profit || transaction.profit || 0;
               overallTotals.totalLoss += transaction.Loss || transaction.loss || 0;
            });
         });
      });

      return overallTotals;
   }, [BillToBillProfit, companyFilter]);

   const dynamicColumns = useMemo(() => {
      const format = reportformat.find((f) => f.id === reportType) || reportformat[0];
      return getColumnsReportsSalesDetail(formatType, reportType, format);
   }, [formatType, reportType, reportformat]);

   const columnsData = useMemo(() => {
      return dynamicColumns.map((col, index) => ({
         key: col?.id,
         label: col?.header,
         title: col?.header,
         width: col?.width,
         index: index + 1,
         status: true,
      }));
   }, [dynamicColumns]);

   const handleShowHideFormOpen = async () => {
      setIsShowHideColumn(true);
      const formatData = reportformat.find((f) => f.title === reportType && f.defName === 'Bill To Bill Profit');
      if (formatData) {
         setIsEditShowHide(true);
         setEditData(formatData);
      } else {
         setIsEditShowHide(false);
         setEditData({});
      }
   };

   const staticReportTypeOptions = [{ value: 'Default', label: 'Default' }];

   const dynamicEditOption = dynamicOptionValues?.formatData.defName;

   const reportTypeOptions = [
      ...staticReportTypeOptions,
      ...(dynamicOptions.length > 0
         ? [
            {
               label: 'Custom Formats',
               options: dynamicOptions,
            },
         ]
         : []),
   ];

   const handleReportTypeChange = (selectedOption) => {
      setReportType(selectedOption.value);
      setExpandedItems({});
      dispatch(getReportFormat());
   };

   const handleDeleteFormat = async (id) => {
      try {
         await dispatch(deleteReportFormat(id));

         if (editData?.id === id) {
            setIsEditShowHide(false);
            setEditData({});
         }
         dispatch(getReportFormat());
      } catch (error) {
         console.error('Delete error:', error);
      }
   };

   const exportToExcel = () => {
      if (!BillToBillProfit || BillToBillProfit.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new workbook
         const wb = XLSX.utils.book_new();

         // Define styles to match UI
         const styles = {
            reportTitle: {
               font: { bold: true, sz: 16 },
               alignment: { horizontal: 'center' },
            },
            dateRange: {
               font: { italic: true, sz: 12 },
               alignment: { horizontal: 'center' },
            },
            formatType: {
               font: { italic: true, sz: 10 },
               alignment: { horizontal: 'center' },
            },
            companyHeader: {
               fill: { fgColor: { rgb: 'F1E7E7' } }, // Light pink
               font: { bold: true, sz: 14, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            daybookHeader: {
               fill: { fgColor: { rgb: 'F5EEE6' } }, // Light tan
               font: { bold: true, sz: 12, color: { rgb: '000000' } },
               alignment: { horizontal: 'left' },
            },
            tableHeader: {
               fill: { fgColor: { rgb: 'F5F5F5' } }, // Light gray
               font: { bold: true, sz: 11, color: { rgb: '000000' } },
               alignment: { horizontal: 'center' },
               border: {
                  top: { style: 'thin', color: { rgb: '000000' } },
                  bottom: { style: 'thin', color: { rgb: '000000' } },
                  left: { style: 'thin', color: { rgb: '000000' } },
                  right: { style: 'thin', color: { rgb: '000000' } },
               },
            },
            oddRow: {
               fill: { fgColor: { rgb: 'FFFFFF' } }, // White
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            evenRow: {
               fill: { fgColor: { rgb: 'EFF6FF' } }, // Very light blue
               font: { sz: 11 },
               border: {
                  top: { style: 'thin', color: { rgb: 'DDDDDD' } },
                  bottom: { style: 'thin', color: { rgb: 'DDDDDD' } },
               },
            },
            numberFormat: {
               numFmt: '#,##0.00',
            },
            currencyFormat: {
               numFmt: '"₹"#,##0.00',
            },
         };

         // Helper function to convert backend color to Excel RGB
         const convertBackendColorToExcel = (backendColor) => {
            if (!backendColor) return '000000'; // Default black

            if (backendColor.startsWith('#')) {
               return backendColor.substring(1).toUpperCase();
            }

            if (backendColor.startsWith('0xff')) {
               return backendColor.substring(4).toUpperCase();
            }

            return '000000'; // Default black
         };

         // Get visible columns based on format type (dynamic or static)
         const getVisibleColumns = () => {
            if (dynamicOptionValues && dynamicOptionValues.formatData?.viewJson) {
               // Dynamic format - use configuration from dynamicOptionValues
               const viewJson = dynamicOptionValues.formatData.viewJson || [];
               return viewJson
                  .filter((item) => item.isShow === true || item.isShow === 'true')
                  .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));
            } else {
               // Static format - use default columns
               return [
                  { defName: 'date', title: 'Date', orderNo: 1 },
                  { defName: 'billno', title: 'Bill No', orderNo: 2 },
                  { defName: 'party', title: 'Party', orderNo: 3 },
                  { defName: 'itemname', title: 'Item Name', orderNo: 4 },
                  { defName: 'serialno', title: 'Serial No#', orderNo: 5 },
                  { defName: 'saleprice', title: 'Sale Price', orderNo: 6 },
                  { defName: 'purchaseprice', title: 'Purchase Price', orderNo: 7 },
                  { defName: 'expenseprice', title: 'Expense Price', orderNo: 8 },
                  { defName: 'profit', title: 'Profit', orderNo: 9 },
               ];
            }
         };

         // Helper function to get cell value based on column definition
         const getCellValue = (row, defName) => {
            switch (defName) {
               case 'serialno':
                  return row.serialNo || '';
               case 'billno':
                  return `${row.prefix || ''}${row.DocNo || ''}${row.postFix || ''}` || '';
               case 'date':
                  return row.txnDate ? formatDate(row.txnDate) : '';
               case 'party':
                  return row.salesAccountName || '';
               case 'itemname':
                  return row.itemName || '';
               case 'saleprice':
                  return row.saleprice || 0;
               case 'purchaseprice':
                  return row.purchaseprice || 0;
               case 'expenseprice':
                  return row.quantity1 || 0; // Based on your original code
               case 'profit':
                  return row.profit || 0;
               default:
                  return '';
            }
         };

         // Helper function to get cell style based on column definition and row data
         const getCellStyle = (row, defName, baseStyle, rowIndex) => {
            let cellStyle = { ...baseStyle };

            // Check if dynamic formatting is enabled
            if (dynamicOptionValues && dynamicOptionValues.formatData?.viewJson) {
               const viewItem = dynamicOptionValues.formatData.viewJson.find((item) => item.defName === defName);

               if (viewItem) {
                  // Apply custom color if specified
                  if (viewItem.color) {
                     const excelColor = convertBackendColorToExcel(viewItem.color);
                     cellStyle.font = {
                        ...cellStyle.font,
                        color: { rgb: excelColor },
                     };
                  }

                  // Apply bold formatting if specified
                  if (viewItem.isBold === 'true' || viewItem.isBold === true) {
                     cellStyle.font = {
                        ...cellStyle.font,
                        bold: true,
                     };
                  }
               }
            }

            // Apply number formatting for numeric columns
            const numericColumns = ['saleprice', 'purchaseprice', 'expenseprice', 'profit'];
            if (numericColumns.includes(defName)) {
               cellStyle = { ...cellStyle, ...styles.numberFormat };
               cellStyle.alignment = { horizontal: 'right' };
            } else if (defName === 'date' || defName === 'billno') {
               cellStyle.alignment = { horizontal: 'center' };
            } else {
               cellStyle.alignment = { horizontal: 'left' };
            }

            return cellStyle;
         };

         const visibleColumns = getVisibleColumns();

         // Process all data for Excel
         const allData = [];
         const mergeRanges = [];
         let currentRow = 0;

         // Add report title
         allData.push([{ v: 'Bill To Bill Profit Report', s: styles.reportTitle }]);
         mergeRanges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: visibleColumns.length - 1 } });
         currentRow++;

         // Add date range
         allData.push([
            {
               v: `From ${formatDate(dateRange?.fromDate || fromDate)} to ${formatDate(dateRange?.toDate || toDate)}`,
               s: styles.dateRange,
            },
         ]);
         mergeRanges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: visibleColumns.length - 1 } });
         currentRow++;

         // Add format type info
         allData.push([
            {
               v: `Format: ${reportType || 'Default'}`,
               s: styles.formatType,
            },
         ]);
         mergeRanges.push({ s: { r: currentRow, c: 0 }, e: { r: currentRow, c: visibleColumns.length - 1 } });
         currentRow++;

         allData.push([]); // Empty row
         currentRow++;

         BillToBillProfit.forEach((companyData) => {
            // Calculate company totals
            const companyTotals = {
               totalSalePrice: 0,
               totalPurchasePrice: 0,
               totalExpensePrice: 0,
               totalProfit: 0,
            };

            companyData.daybook?.forEach((daybookData) => {
               const daybookTotals = calculateDaybookTotals(daybookData.data);
               companyTotals.totalSalePrice += daybookTotals.totalSalePrice || 0;
               companyTotals.totalPurchasePrice += daybookTotals.totalPurchasePrice || 0;
               companyTotals.totalExpensePrice +=
                  daybookData.data?.reduce((sum, t) => sum + (t.quantity1 || 0), 0) || 0;
               companyTotals.totalProfit += daybookTotals.totalProfit || 0;
            });

            // Add company header row with totals
            const companyRow = visibleColumns.map((col) => {
               let value = '';
               let cellStyle = { ...styles.companyHeader };

               switch (col.defName) {
                  case 'party':
                     value = companyData.companyName;
                     break;
                  case 'saleprice':
                     value = companyTotals.totalSalePrice;
                     cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                     break;
                  case 'purchaseprice':
                     value = companyTotals.totalPurchasePrice;
                     cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                     break;
                  case 'expenseprice':
                     value = companyTotals.totalExpensePrice;
                     cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                     break;
                  case 'profit':
                     value = companyTotals.totalProfit;
                     cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                     break;
               }

               return { v: value, t: typeof value === 'number' ? 'n' : 's', s: cellStyle };
            });

            allData.push(companyRow);
            currentRow++;

            allData.push([]); // Empty row
            currentRow++;

            // Process daybooks
            companyData.daybook?.forEach((daybookData) => {
               const daybookTotals = calculateDaybookTotals(daybookData.data);

               // Add daybook header row with totals
               const daybookRow = visibleColumns.map((col) => {
                  let value = '';
                  let cellStyle = { ...styles.daybookHeader };

                  switch (col.defName) {
                     case 'party':
                        value = daybookData.daybookName;
                        break;
                     case 'saleprice':
                        value = daybookTotals.totalSalePrice;
                        cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                        break;
                     case 'purchaseprice':
                        value = daybookTotals.totalPurchasePrice;
                        cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                        break;
                     case 'expenseprice':
                        value = daybookData.data?.reduce((sum, t) => sum + (t.quantity1 || 0), 0) || 0;
                        cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                        break;
                     case 'profit':
                        value = daybookTotals.totalProfit;
                        cellStyle = { ...cellStyle, ...styles.numberFormat, alignment: { horizontal: 'right' } };
                        break;
                  }

                  return { v: value, t: typeof value === 'number' ? 'n' : 's', s: cellStyle };
               });

               allData.push(daybookRow);
               currentRow++;

               allData.push([]); // Empty row
               currentRow++;

               // Add table headers
               const headers = visibleColumns.map((col) => ({
                  v: col.title || col.defName,
                  s: styles.tableHeader,
               }));
               allData.push(headers);
               currentRow++;

               // Add transaction data with alternating row colors and dynamic formatting
               daybookData.data?.forEach((transaction, index) => {
                  const baseRowStyle = index % 2 === 0 ? styles.evenRow : styles.oddRow;

                  const transactionRow = visibleColumns.map((col) => {
                     const value = getCellValue(transaction, col.defName);
                     const cellStyle = getCellStyle(transaction, col.defName, baseRowStyle, index);

                     return {
                        v: value,
                        t: typeof value === 'number' ? 'n' : 's',
                        s: cellStyle,
                     };
                  });

                  allData.push(transactionRow);
                  currentRow++;
               });

               allData.push([]); // Empty row after each daybook
               currentRow++;
            });
         });

         // Create worksheet
         const ws = XLSX.utils.aoa_to_sheet(allData);

         // Set column widths based on visible columns
         const getColumnWidths = () => {
            const widthMap = {
               date: 12,
               billno: 15,
               party: 25,
               itemname: 25,
               serialno: 20,
               saleprice: 15,
               purchaseprice: 15,
               expenseprice: 15,
               profit: 15,
            };

            return visibleColumns.map((col) => ({
               wch: widthMap[col.defName] || 15,
            }));
         };

         ws['!cols'] = getColumnWidths();

         // Add merge ranges
         ws['!merges'] = mergeRanges;

         // Add worksheet to workbook
         XLSX.utils.book_append_sheet(wb, ws, 'Bill To Bill Profit');

         // Generate safe file name with format type
         const now = new Date();
         const formatSuffix = reportType && reportType !== 'Default' ? `_${reportType.replace(/\s+/g, '_')}` : '';
         const safeFileName = `Bill_To_Bill_Profit${formatSuffix}_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.xlsx`;

         // Write file
         XLSX.writeFile(wb, safeFileName);
      } catch (error) {
         console.error('Error exporting to Excel:', error);
         alert('Failed to export Excel file. Please try again.');
      }
   };

   const exportToPDF = () => {
      if (!BillToBillProfit || BillToBillProfit.length === 0) {
         alert('No data to export');
         return;
      }

      try {
         // Create a new PDF document in landscape mode
         const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
         });

         // Add report title
         const pageWidth = doc.internal.pageSize.getWidth();
         const centerX = pageWidth / 2;

         doc.setFontSize(16);
         doc.setFont('helvetica', 'bold');
         doc.text('Bill To Bill Profit Report', centerX, 10, { align: 'center' });

         // Add date range
         doc.setFontSize(12);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `From ${formatDate(dateRange?.fromDate || fromDate)} to ${formatDate(dateRange?.toDate || toDate)}`,
            centerX,
            18,
            { align: 'center' },
         );

         // Add format type info
         doc.setFontSize(10);
         doc.setFont('helvetica', 'italic');
         doc.text(`Format: ${reportType}`, centerX, 25, { align: 'center' });

         // Define styles
         const styles = {
            header: {
               fillColor: [241, 231, 231], // Light pink - company header
               textColor: 0, // Black
               fontStyle: 'bold',
               fontSize: 8,
            },
            subHeader: {
               fillColor: [245, 238, 230], // Light tan - daybook header
               textColor: '#000000',
               fontStyle: 'bold',
               fontSize: 8,
            },
            tableHeader: {
               fillColor: [245, 245, 245], // Light gray
               textColor: 0,
               fontStyle: 'bold',
               fontSize: 8,
            },
            oddRow: {
               fillColor: [255, 255, 255], // White
               textColor: '#000000',
               fontSize: 8,
            },
            evenRow: {
               fillColor: [239, 246, 255], // Very light blue
               textColor: '#000000',
               fontSize: 8,
            },
            totalRow: {
               fillColor: [248, 250, 252], // Very light gray
               textColor: 0,
               fontStyle: 'bold',
               fontSize: 8,
            },
         };

         // Get visible columns based on format type
         const getVisibleColumns = () => {
            if (dynamicOptionValues) {
               const viewJson = dynamicOptionValues?.formatData?.viewJson || [];
               return viewJson
                  .filter((item) => item.isShow === true || item.isShow === 'true')
                  .sort((a, b) => (parseInt(a.orderNo) || 0) - (parseInt(b.orderNo) || 0));
            } else {
               // Default columns
               return [
                  { defName: 'date', title: 'Date', orderNo: 1 },
                  { defName: 'billno', title: 'Bill No', orderNo: 2 },
                  { defName: 'party', title: 'Party', orderNo: 3 },
                  { defName: 'itemname', title: 'Item Name', orderNo: 4 },
                  { defName: 'serialno', title: 'Serial No#', orderNo: 5 },
                  { defName: 'saleprice', title: 'Sale Price', orderNo: 6 },
                  { defName: 'purchaseprice', title: 'Purchase Price', orderNo: 7 },
                  { defName: 'expenseprice', title: 'Expense Price', orderNo: 8 },
                  { defName: 'profit', title: 'Profit', orderNo: 9 },
               ];
            }
         };

         const visibleColumns = getVisibleColumns();

         // Helper function to convert backend color
         const convertBackendColor = (backendColor) => {
            if (!backendColor) return [0, 0, 0]; // Default black
            if (backendColor.startsWith('#')) {
               const hex = backendColor.substring(1);
               const r = parseInt(hex.substring(0, 2), 16);
               const g = parseInt(hex.substring(2, 4), 16);
               const b = parseInt(hex.substring(4, 6), 16);
               return [r, g, b];
            }
            if (backendColor.startsWith('0xff')) {
               const hex = backendColor.substring(4);
               const r = parseInt(hex.substring(0, 2), 16);
               const g = parseInt(hex.substring(2, 4), 16);
               const b = parseInt(hex.substring(4, 6), 16);
               return [r, g, b];
            }
            return [0, 0, 0]; // Default black
         };

         // Helper function to get cell value
         const getCellValue = (row, defName) => {
            switch (defName) {
               case 'serialno':
                  return row.serialNo || '-';
               case 'billno':
                  return `${row.prefix || ''}${row.DocNo || ''}${row.postFix || ''}` || '-';
               case 'date':
                  return formatDate(row.txnDate);
               case 'party':
                  return row.salesAccountName || '-';
               case 'itemname':
                  return row.itemName || '-';
               case 'saleprice':
                  return row.saleprice !== undefined && row.saleprice !== null
                     ? row.saleprice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                     : '-';
               case 'purchaseprice':
                  return row.purchaseprice !== undefined && row.purchaseprice !== null
                     ? row.purchaseprice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                     : '-';
               case 'expenseprice':
                  return row.expenseprice !== undefined && row.expenseprice !== null
                     ? row.expenseprice.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                     : '-';
               case 'profit':
                  return row.profit !== undefined && row.profit !== null
                     ? row.profit.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                     : '-';
               default:
                  return '-';
            }
         };

         // Define column styles for alignment based on visible columns
         const getColumnStyles = () => {
            const columnStyles = {};
            visibleColumns.forEach((col, index) => {
               const isNumeric = ['saleprice', 'purchaseprice', 'expenseprice', 'profit'].includes(col.defName);
               columnStyles[index] = {
                  cellWidth: 'auto',
                  halign: isNumeric ? 'right' : col.defName === 'date' || col.defName === 'billno' ? 'center' : 'left',
               };
            });
            return columnStyles;
         };

         const columnStyles = getColumnStyles();

         let startY = 32; // Starting Y position after title, date, and format

         // Process each company
         BillToBillProfit.forEach((companyData, companyIdx) => {
            const companyTotals = calculateCompanyTotals(companyData.daybook);

            // Prepare company totals row data
            const companyTotalCells = visibleColumns.map((col) => {
               switch (col.defName) {
                  case 'party':
                     return companyData.companyName;
                  case 'saleprice':
                     return companyTotals.totalSalePrice.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     });
                  case 'purchaseprice':
                     return companyTotals.totalPurchasePrice.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     });
                  case 'expenseprice':
                     return companyTotals.totalExpensePrice.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     });
                  case 'profit':
                     return companyTotals.totalProfit.toLocaleString('en-IN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                     });
                  default:
                     return '';
               }
            });

            // Add company totals row
            doc.autoTable({
               head: [],
               body: [companyTotalCells],
               startY,
               margin: { left: 10, right: 10 },
               bodyStyles: {
                  fillColor: styles.header.fillColor,
                  textColor: styles.header.textColor,
                  fontStyle: styles.header.fontStyle,
                  fontSize: styles.header.fontSize,
               },
               columnStyles: columnStyles,
            });

            // Process each daybook
            companyData.daybook?.forEach((daybookData, daybookIdx) => {
               const daybookTotals = calculateDaybookTotals(daybookData.data);
               const daybookTotalCells = visibleColumns.map((col) => {
                  switch (col.defName) {
                     case 'party':
                        return daybookData.daybookName;
                     case 'saleprice':
                        return daybookTotals.totalSalePrice.toLocaleString('en-IN', {
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                        });
                     case 'purchaseprice':
                        return daybookTotals.totalPurchasePrice.toLocaleString('en-IN', {
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                        });
                     case 'expenseprice':
                        return daybookTotals.totalExpensePrice.toLocaleString('en-IN', {
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                        });
                     case 'profit':
                        return daybookTotals.totalProfit.toLocaleString('en-IN', {
                           minimumFractionDigits: 2,
                           maximumFractionDigits: 2,
                        });
                     default:
                        return '';
                  }
               });

               // Prepare table headers (only once at the beginning of each daybook)
               const headers = visibleColumns.map((col) => col.title || col.defName);

               // Prepare table body with custom styling
               const body =
                  daybookData.data?.map((row, index) => {
                     return visibleColumns.map((col) => getCellValue(row, col.defName));
                  }) || [];

               // Add daybook totals + headers + data in one table
               const combinedBody = [daybookTotalCells, ...body];

               // Create custom body styles for dynamic formatting
               const bodyStyles = {};
               if (dynamicOptionValues) {
                  daybookData.data?.forEach((row, rowIndex) => {
                     visibleColumns.forEach((col, colIndex) => {
                        const viewItem = dynamicOptionValues.formatData?.viewJson?.find(
                           (item) => item.defName === col.defName,
                        );
                        if (viewItem) {
                           const cellKey = `${rowIndex + 1}-${colIndex}`; // +1 because first row is daybook total
                           bodyStyles[cellKey] = {
                              textColor: viewItem.color ? convertBackendColor(viewItem.color) : styles.oddRow.textColor,
                              fontStyle: viewItem.isBold === 'true' || viewItem.isBold === true ? 'bold' : 'normal',
                           };
                        }
                     });
                  });
               }

               // Add the complete table with daybook totals, headers, and data
               doc.autoTable({
                  head: [headers],
                  body: combinedBody,
                  startY: startY + 8,
                  margin: { left: 10, right: 10 },
                  headStyles: {
                     fillColor: styles.tableHeader.fillColor,
                     textColor: styles.tableHeader.textColor,
                     fontStyle: styles.tableHeader.fontStyle,
                     fontSize: styles.tableHeader.fontSize,
                     halign: 'center',
                  },
                  bodyStyles: {
                     textColor: styles.tableHeader.textColor,
                     fontSize: 8,
                  },
                  alternateRowStyles: {
                     textColor: styles.tableHeader.textColor,
                     fillColor: styles.evenRow.fillColor,
                  },
                  columnStyles: columnStyles,
                  didParseCell: (data) => {
                     if (data.section === 'body') {
                        // Style the first row (daybook totals) differently
                        if (data.row.index === 0) {
                           data.cell.styles.fillColor = styles.subHeader.fillColor;
                           data.cell.styles.textColor = styles.subHeader.textColor;
                           data.cell.styles.fontStyle = styles.subHeader.fontStyle;
                           data.cell.styles.fontSize = styles.subHeader.fontSize;
                        } else if (dynamicOptionValues) {
                           // Apply custom styling for data rows (index > 0)
                           const cellKey = `${data.row.index}-${data.column.index}`;
                           const customStyle = bodyStyles[cellKey];
                           if (customStyle) {
                              if (customStyle.textColor) {
                                 data.cell.styles.textColor = customStyle.textColor;
                              }
                              if (customStyle.fontStyle === 'bold') {
                                 data.cell.styles.fontStyle = 'bold';
                              }
                           }
                        }
                     }
                  },
                  didDrawPage: (data) => {
                     startY = data.cursor.y + 5; // Reduced gap
                  },
               });
            });

            // Add a new page if there's more data
            if (companyIdx < BillToBillProfit.length - 1) {
               doc.addPage('landscape');
               startY = 20;
            }
         });

         // Generate safe file name with format type
         const now = new Date();
         const formatSuffix = reportType !== 'Default' ? `_${reportType.replace(/\s+/g, '_')}` : '';
         const safeFileName = `Bill_To_Bill_Profit${formatSuffix}_${now.getFullYear()}${(now.getMonth() + 1)
            .toString()
            .padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}.pdf`;

         // Save the PDF
         doc.save(safeFileName);
      } catch (error) {
         console.error('Error exporting to PDF:', error);
         alert('Failed to export PDF file. Please try again.');
      }
   };

   const formatOptionLabel = ({ label, isDynamic, id }, { context }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
         <span>{label}</span>
         {isDynamic && context === 'menu' && (
            <button
               onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteFormat(id);
               }}
               style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ff4d4f',
                  padding: '0 5px',
               }}
               title="Delete this format">
               <MdDelete />
            </button>
         )}
      </div>
   );

   const staticOption = staticReportTypeOptions.find((option) => option.value === reportType);

   return (
      <>
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Serial Wise Bill To Bill Profit
               </Text>
            </Flex>
            <Flex gap={2}>
               <Box cursor={'pointer'} onClick={() => handleShowHideFormOpen()} mr={2}>
                  {isStaticReportType ? <FiPlusCircle size={22} /> : <LucideEdit size={22} />}
               </Box>
               <Button size="sm" variant="outline" onClick={expandAll} leftIcon={<MdExpand />}>
                  Expand All
               </Button>
               <Button size="sm" variant="outline" onClick={collapseAll} leftIcon={<MdCompress />}>
                  Collapse All
               </Button>
            </Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent="end">
               <Flex flex="" gap={2} mr={3} display={{ base: 'none', xl: 'block' }}>
                  <div flex="1" mr={''} justifyContent="center">
                     <Box
                        my={2}
                        width="300px"
                        fontSize={'13px'}
                        fontWeight={500}
                        display={{ base: 'none', lg: 'block' }}>
                        <GridItem className="seperator-width" w={'100%'} mt={5}>
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                     </Box>
                  </div>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last30Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Flex>
                     <Box my={2} zIndex={15} fontSize={'13px'} fontWeight={500}>
                        <label>Format</label>
                        <Select
                           options={reportTypeOptions}
                           formatOptionLabel={formatOptionLabel}
                           value={reportTypeOptions.find((option) => option.value === reportType)}
                           onChange={handleReportTypeChange}
                           placeholder="Select Report Type"
                           styles={{
                              control: (baseStyles, state) => ({
                                 ...baseStyles,
                                 minHeight: '30px',
                                 height: '30px',
                                 backgroundColor: controlBg,
                                 borderColor: controlBorder,
                                 boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                                 '&:hover': {
                                    borderColor: controlBorderHover,
                                 },
                              }),
                              valueContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                                 padding: '0 6px',
                                 color: textColor,
                              }),
                              indicatorsContainer: (baseStyles) => ({
                                 ...baseStyles,
                                 height: '30px',
                              }),
                              singleValue: (baseStyles) => ({
                                 ...baseStyles,
                                 color: textColor,
                              }),
                              placeholder: (baseStyles) => ({
                                 ...baseStyles,
                                 color: placeholderColor,
                              }),
                              option: (baseStyles, state) => ({
                                 ...baseStyles,
                                 backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                                 color: textColor,
                                 fontWeight: state.data?.isDynamic ? 'bold' : 'normal',
                                 '&:hover': {
                                    backgroundColor: optionHoverBg,
                                 },
                              }),
                              groupHeading: (baseStyles) => ({
                                 ...baseStyles,
                                 backgroundColor: menuBg,
                                 border: `1px solid ${menuBorder}`,
                              }),
                              dropdownIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                              clearIndicator: (baseStyles) => ({
                                 ...baseStyles,
                                 color: indicatorColor,
                                 '&:hover': {
                                    color: indicatorHoverColor,
                                 },
                              }),
                           }}
                        />
                     </Box>
                  </Flex>
               </Flex>
               <Flex className="flex flex-wrap gap-2">
                  <Flex>
                     <Box flex="1" mr={3}>
                        <MotionFlex
                           ref={wrapperRef}
                           align="center"
                           bg={bg}
                           borderRadius="full"
                           cursor="pointer"
                           px={expanded ? 3 : 0}
                           w={expanded ? '250px' : '40px'}
                           h="40px"
                           transition="all 0.3s ease"
                           onClick={() => setExpanded(true)}>
                           <MotionSearchIcon
                              color={icon}
                              animate={{ rotate: expanded ? 0 : 90 }}
                              transition={{ duration: 0.3 }}
                              style={{
                                 marginRight: expanded ? '8px' : '10px',
                                 marginLeft: expanded ? '0' : '10px',
                              }}
                           />
                           {expanded && (
                              <Input
                                 variant="unstyled"
                                 placeholder="Search ..."
                                 value={searchQuery}
                                 onChange={handleSearchChange}
                                 autoFocus
                                 color={icon}
                                 flex="1"
                              />
                           )}
                        </MotionFlex>
                     </Box>
                     <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                        <LuRefreshCcw size={20} mr={2} />
                     </Button>

                     <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                        <IoFilterOutline size={22} />
                     </Button>

                     <Popover>
                        <PopoverTrigger>
                           <img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} />
                        </PopoverTrigger>
                        <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                           <PopoverBody p="3">
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={exportToExcel}
                                 justifyContent="space-between"
                                 mb={3}>
                                 <img src={xls} alt="Download XLS" width="30px" />
                                 Download Excel
                              </Button>
                              <Button
                                 width="100%"
                                 variant="ghost"
                                 _hover={{ bg: 'blue.100' }}
                                 onClick={exportToPDF}
                                 justifyContent="space-between">
                                 <img src={xls} alt="Download Pdf" width="30px" mr />
                                 Download Pdf
                              </Button>
                           </PopoverBody>
                        </PopoverContent>
                     </Popover>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} width="100%" fontSize={'13px'} fontWeight={500}>
                           <label>Account</label>
                           <Select
                              placeholder="Select Account"
                              name="accountId"
                              options={accountOptions}
                              onChange={handleAccountChange}
                              value={accountOptions.find((option) => option.value === accountId)}
                              isMulti={false}
                              isClearable
                              className="basic-multi-select"
                              classNamePrefix="select"
                              styles={{
                                 control: (baseStyles) => ({
                                    ...baseStyles,
                                    minHeight: '30px',
                                    height: '30px',
                                 }),
                                 valueContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                    padding: '0 6px',
                                 }),
                                 indicatorsContainer: (baseStyles) => ({
                                    ...baseStyles,
                                    height: '30px',
                                 }),
                              }}
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last30Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  color={textColor}
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                           <Text fontWeight={600} fontSize="14px"
                              color={isDark ? '#a5b4fc' : '#4338ca'}>
                              Applying filters...
                           </Text>
                        </Flex>
                     </Box>
                  )}

                  <Table variant="simple" mb="24px" mt="12px">
                     <Tbody>
                        <VirtualizedTable
                           data={BillToBillProfit}
                           isLoading={isLoading}
                           expandedItems={expandedItems}
                           toggleExpand={toggleExpand}
                           textColor={textColor}
                           borderColor={borderColor}
                           setIsOpenPurchaseReturnSingleView={setIsOpenPurchaseReturnSingleView}
                           setEntityType={setEntityType}
                           setIsOpenSingleViewinr={setIsOpenSingleViewinr}
                           dynamicOptionValues={dynamicOptionValues}
                           containerHeight={600} // You can adjust this height as needed
                           calculateOverallGrandTotals={calculateOverallGrandTotals}
                        />
                     </Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         <SalesDetails
            isOpen={isOpenPurchaseReturnSingleView}
            onClose={handleSalesDetailsClose}
            singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
            title={
               entityType === 'saleinvoice'
                  ? 'Sales Invoice'
                  : entityType === 'salereturn'
                     ? 'Sales Return'
                     : entityType === 'purchaseinvoice'
                        ? 'Purchase Invoice'
                        : 'Purchase Return'
            }
            entityType={entityType}
            singleEntity={viewDetail}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            setIsEditFormOpen={setIsEditFormOpen}
            setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
            isEditFormOpen={isEditFormOpen}
            viewDetail={viewDetail}
            lineItems={viewDetail?.lineitems}
            billTerms={viewDetail?.purchasereturnbillteams}
            onDelete={deletePurchaseReturn}
            handleSerchClose={() => {
               console.log('');
            }}
         />

         <SalesPurchaseFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyIds}
            fromDate={dateRange.fromDate}
            toDate={dateRange.toDate}
            entityType={'BillToBillProfit'}
            onApply={() => setIsFilterLoading(true)}
         />

         <SalesSingleDataView
            isOpenSingleView={isOpenSingleViewinr}
            onClose={handleSalesSingleDataViewClose}
            entityType={entityType}
            singleEntity={singleEntity}
            dynamicUserDetails={dynamicUserDetails}
            onEditFormClose={() => setIsOpenSingleViewinr(true)}
            setIsOpenSingleView={setIsOpenSingleViewinr}
            isEditFormOpen={isEditFormOpen}
            setIsEditFormOpen={setIsEditFormOpen}
            title={entityType === 'issuemaster' ? 'Issue' : 'Receive'}
            handleViewSingleData={handleViewSingleData}
         />

         <ColumnShowHide
            isOpen={isShowHideColumn}
            onClose={() => setIsShowHideColumn(false)}
            data={columnsData}
            setShowHideData={setShowHideData}
            isedit={isEditShowHide}
            editData={editData}
            selectedFormat={reportTypeOptions.dynamicOptions}
            FixdefName1={'Bill To Bill Profit'}
            staticOption={staticOption}
            dynamicEditOption={dynamicEditOption}
         />
      </>
   );
};

export default BillToBillProfit;
